import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { serviceTaskSchema } from "@opstel/query/v2/serviceTasksParser";
import { ServiceTask } from "@opstel/query/v2/models/serviceTask";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

export function useServiceTasksQuery(): UseQueryResult<ServiceTask[]> {
  const { opstelClient } = useOpstelClient();
  const { instanceId } = useCurrentInstanceId();

  return useQuery({
    queryKey: instances.current(instanceId).serviceTasks,
    queryFn: () => opstelClient.getServiceTasks({ instanceId: instanceId ?? "" }),
    select: (serviceTasks): ServiceTask[] => z.array(serviceTaskSchema).parse(serviceTasks),
    enabled: !!instanceId,
  });
}
